import model from 'modules/bot/botModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.phoneNumberId,
  fields.messages,
  fields.cluster,
  fields.enable,
  fields.createdAt,
  fields.updatedAt,
];
